import { render, staticRenderFns } from "./LmCardMore.vue?vue&type=template&id=27638c87"
import script from "./LmCardMore.vue?vue&type=script&lang=js"
export * from "./LmCardMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports